import { render, staticRenderFns } from "./PracticeMissingPage.vue?vue&type=template&id=5e035c2c"
import script from "./PracticeMissingPage.vue?vue&type=script&lang=js"
export * from "./PracticeMissingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports